import { render } from "./MenuComponent.vue?vue&type=template&id=f110e9ce&scoped=true&ts=true"
import script from "./MenuComponent.vue?vue&type=script&lang=ts"
export * from "./MenuComponent.vue?vue&type=script&lang=ts"

import "./MenuComponent.vue?vue&type=style&index=0&id=f110e9ce&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f110e9ce"]])

export default __exports__